<template>
  <div :class="['app-messaging', 'messager', {'collapse': hasConversations, 'in': sideBarIn, 'popup': popup}]">
    <div class="chat-group" v-if="hasConversations">
      <div class="heading">{{ $t('Messages.title') }}</div>
      <ul class="group full-height">
        <!--
        <li class="section">unread</li>
        -->
        <li v-for="(conversation, index) in conversations" class="message message-list">
          <a
                  data-toggle="collapse"
                  aria-expanded="false"
                  aria-controls="collapseMessaging"
                  :class="conversationId === conversation.orderId ? 'active' : 'collapsed'"
                  @click="emitOpenMessage(conversation)"
          >
            <span v-if="conversation.counter > conversation.read" class="badge badge-warning pull-right">
              {{ conversation.counter - conversation.read }}
            </span>
            <div class="message">
              <div class="profile profile-circle">
                <i class="fa fa-user"></i>
              </div>
              <div class="content">
                <div class="title">{{ conversation.transactionnum }}</div>
                <div class="description">{{ conversation.lastText | shortenText }}</div>
                <div class="description ptop-5">{{ conversation.lastDate | formatTime }}</div>
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>
    <div class="messaging">
      <div v-if="title" class="heading">
        <div class="title">
          <a class="btn-back" data-toggle="collapse" href="#collapseMessaging" aria-expanded="true" aria-controls="collapseMessaging" v-on:click="emitCollapse">
            <i class="fa fa-angle-left" aria-hidden="true"></i>
          </a>
          <slot name="title">
            {{ title }}
          </slot>
        </div>
        <div class="action"></div>
      </div>
      <ul class="chat" ref="chatbox">
        <template v-for="(messages, day) in messagesByDay">
          <li class="line">
            <div class="title">{{ day }}</div>
          </li>
          <li v-for="message in messages" :class="messageClass(message)">
            <div class="message">{{ message.text }}</div>
            <div v-if="Array.isArray(message.files) && message.files.length">
              <i class="fas fa-paperclip"/>
              <a v-for="attachment in message.files" href="javascript: void 0" @click="handleDownload(attachment, message)">
                <i :class="`fas ${getFileIcon(attachment)}`"/>
                {{attachment.filename}} ({{humanizeFileSize(attachment.size)}})
              </a>
            </div>
            <div class="info">
              <div class="datetime">{{ message.date | formatTime }}</div>
              <div class="status" v-html="authorInfo(message)"></div>
            </div>
          </li>
        </template>
      </ul>
      <div class="footer" v-if="conversationId">
        <div class="message-box">
          <textarea ref="input" :placeholder="$t('Messages.writeSomething')" class="form-control" :value="value" v-on:input="updateValue($event.target.value)" @keyup.enter="sendMessage"></textarea>
          <div class="attach-file-btn">
            <input type="file" ref="file" @change="attachFile"/>
            <i class="fas fa-paperclip"/>
          </div>
          <button class="btn btn-default" v-on:click="sendMessage" :disabled="activeRequest">
            <i :class="['fa', {'fa-paper-plane': !activeRequest, 'fa-spinner': activeRequest, 'fa-spin': activeRequest}]" aria-hidden="true"></i>
            <span>{{ $t('Action.send') }}</span>
          </button>
          <div class="selected-files" v-if="files.length">
            <i class="fas fa-paperclip"/>
            <a v-for="attachment in files" href="javascript: void 0" @click="removeFile(attachment)">
              <i :class="`fas ${getFileIcon(attachment)}`"/>
              {{attachment.name}} ({{humanizeFileSize(attachment.size)}})
              <i class="fas fa-cross"/>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import saveAs from 'file-saver';

export default {
  filters: {
    shortenText(text) {
      if (text && text.length > 35)
        return text.substring(0, 32) + '...';
      else
        return text || '';
    }
  },
  props: {
    conversations: {
      type: Array,
      default() {
        return [];
      }
    },
    title: {
      type: String
    },
    messages: {
      type: Array,
      default() {
        return [];
      }
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    value: {
      type: String
    },
    activeRequest: {
      type: Boolean,
      default: false
    },
    popup: {
      tyoe: Boolean,
      default: false
    },
    conversationId: {}
  },
  computed: {
    hasConversations() {
      return this.conversations.length > 0;
    },
    sideBarIn() {
      return this.hasConversations && !this.collapsed;
    },
    messagesByDay() {
      var msgByDay = {},
          options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };

      this.messages.forEach(function(msg) {
        var time = new Date(msg.date * 1000),
            day = new Date(time.getFullYear(), time.getMonth(), time.getDate()),
            key = day.toLocaleString('de-DE', options);

        if (typeof msgByDay[key] == 'undefined') {
          msgByDay[key] = [];
        }

        msgByDay[key].push(msg);
      });

      return msgByDay;
    }
  },
  data() {
    return {
      files: [],
    }
  },
  methods: {
    loadConversation(conversationId) {
      if (typeof conversationId == 'undefined') {
        if (this.conversationId == null || this.conversationId == '') {
          console.log('loadConversation: No conversationId');
          return;
        }
        conversationId = this.conversationId;
      }

      this.$http.get(this.$root.url + 'message/' + conversationId).then(
        function(res) {
          this.$emit('updateconversation', res.data.result.messages);
          setTimeout(function() {
            const scrollBottom = () => {
              if (this.$refs.chatbox) {
                this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
              } else {
                setTimeout(scrollBottom, 100);
              }
            }
            scrollBottom();

            // https://app.dentadesk.com/demo/api/message/:orderId/?commentId=:commentId

            const ID = Math.max(0, ... (res.data.result.messages || []).map(x => x.ID));
            console.log('last message ID', ID);
            if (ID) {
              this.$http.post(this.$root.url + 'message/' + conversationId + '?commentId=' + ID)
                      .catch(console.error)
                      .then(x => {
                        this.$emit('read-updated', conversationId)
                      });
            }
          }.bind(this), 300);
        }.bind(this),
        function(res) {
          console.log('Error loading messages', res);
          // this.$emit('alert', 'Nachricht konnte nicht gesendet werden.');
        }.bind(this));
    },
    async sendMessage() {
      this.updateValue(this.value.trim());

      if (this.value.trim() == '' && this.files.length == 0) {
        return;
      }

      this.$emit('alert'); // Close alerts
      this.$emit('showloader');

      const formData = new FormData();

      formData.append('orderId', this.conversationId);
      formData.append('text', this.value.trim());

      this.files.forEach((file, index) => {
        formData.append(`attachment${index}`, file);
      });

      try {
        const res = await this.$http.post(this.$root.url + 'message/', formData);
        this.$emit('messageadded', res.data.result);
        this.updateValue('');
        this.files = [];
        this.loadConversation();
      } catch (e) {
        console.error(e);
        this.$emit('alert', this.$t('Messages.errorSendingMessage'));
      } finally {
        this.$emit('hideloader');
      }
    },
    messageClass(message) {
      if (this.$parent.getUser && this.$parent.getUser().fullname === message.sender) {
        return 'agent';
      }
      if (this.$parent.$parent.getUser && this.$parent.$parent.getUser().fullname === message.sender) {
        return 'agent';
      }
      return '';
    },
    authorInfo(message) {
      return message.sender;
    },
    emitOpenMessage(conversationId) {
      this.$emit('open', conversationId);
    },
    emitCollapse() {
      this.$emit('collapse');
    },
    updateValue(value) {
      this.$refs.input.value = value;
      this.$emit('input', value);
    },
    async handleDownload(attachment, message) {
      attachment.downloading = true;
      this.$forceUpdate();

      const params = { responseType: 'arraybuffer' }; // or { responseType: 'blob' }
      try {
        const {body} = await this.$http
          .get(this.$root.url + 'message/' + this.conversationId + '/' + message.ID + '/' + attachment.filename, params);

        const blob = new Blob([body], {type: attachment.mimetype});
        saveAs(blob, attachment.filename);

      } finally {
        delete attachment.downloading;
        this.$forceUpdate();
      }
    },
    humanizeFileSize(size) {
      size = parseInt(size, 10);
      const scales = ['B', 'KB', 'MB', 'GB'];
      let index = 0;
      while (size > 1024 && index < scales.length -1) {
        size = size / 1024;
        ++index;
      }

      return `${size.toFixed(1)}${scales[index]}`;
    },
    attachFile() {
      this.files = [...this.files, ...this.$refs.file.files];
    },
    removeFile(file) {
      this.files = this.files.filter(x => x !== file);
    },
    getFileIcon({mimetype, downloading, type: contenttype}) {
      if (downloading) {
        return 'fa-spinner fa-spin';
      }
      const [mime, type] = (mimetype || contenttype).split('/');
      switch (mime) {
        // Media
        case 'image':
          return 'fa-file-image';
        case 'audio':
          return 'fa-file-audio';
        case 'video':
          return 'fa-file-video';

        case 'text':
          switch (type) {
            case 'html':
              return 'fa-file-code';
            default:
              return 'fa-file-text';
          }

        case 'application':
          switch (type) {
            case 'pdf':
              return 'fa-file-pdf';

            case 'msword':
            case 'vnd.ms-word':
            case 'vnd.oasis.opendocument.text':
            case 'vnd.openxmlformats-officedocument.wordprocessingml':
              return 'fa-file-word';

            case 'vnd.ms-excel':
            case 'vnd.openxmlformats-officedocument.spreadsheetml':
            case 'vnd.oasis.opendocument.spreadsheet':
              return 'fa-file-excel';

            case 'vnd.ms-powerpoint':
            case 'vnd.openxmlformats-officedocument.presentationml':
            case 'vnd.oasis.opendocument.presentation':
              return 'fa-file-powerpoint';

            case 'json':
              return 'fa-file-code';

            case 'gzip':
            case 'zip':
            case 'x-zip-compressed':
              return 'fa-file-archive';
          }
      }

      return 'fa-file-download';
    },
  }
};
</script>
<style scoped>
  .message-list .active {
    background: #f8f8f9;
  }
  .attach-file-btn {
    cursor: pointer;
    position: relative;
    font-size: 16px;
    display: inline-block;
    margin: 5px 5px 0 0;
    z-index: 1;
    overflow: hidden;
  }
  .attach-file-btn input[type=file] {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
    z-index: 1;
  }

  .attach-file-btn:hover {
    cursor: pointer;
  }

  .message-box {
    position: relative;
  }

  .message-box textarea {
    margin-right: -20px;
  }

  .selected-files {
    position: absolute;
    bottom: 5px;
    right: 85px;
    left: 10px;
  }

  .profile-circle {
    border-radius: 50%;
    background: #ccc;
    font-size: 16pt;
    text-align: center;
    padding-top: 5px;
    color: white;
  }
</style>
